import { Checkbox, FormControlLabel } from "@mui/material";
import { FC, memo } from "react";

/** Same layout for every field checkbox — FormControlLabel’s default negative margin is reset so rows align with TextFields and with each other. */
export const FieldFormCheckboxRow: FC<{
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = memo(({ label, checked, onChange }) => (
  <FormControlLabel
    sx={{ ml: 0, mr: 0, display: "flex", alignItems: "center" }}
    control={(
      <Checkbox
        size='small'
        checked={checked}
        onChange={(_, v) => onChange(v)}
      />
    )}
    label={label}
  />
));
